import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "@/theme/muiTheme";
import AppShell from "@/layout/AppShell";
import ClinOpsRoutes from "@/pages/clinops";
import DashboardRoutes from "@/pages/dashboard";
import NotFound from "@/pages/NotFound";
import NoAccess from "@/pages/NoAccess";
import AuthError from "@/pages/AuthError";
import { AuthProvider } from "@/auth/AuthProvider";
import LoginPage from "@/auth/LoginPage";
import ProtectedRoute from "@/auth/ProtectedRoute";
import TabGuard from "@/auth/TabGuard";
import DefaultTabRedirect from "@/auth/DefaultTabRedirect";

export default function App() {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<AppShell />}>
                <Route index element={<DefaultTabRedirect />} />
                <Route path="no-access" element={<NoAccess />} />
                <Route path="auth-error" element={<AuthError />} />
                <Route
                  path="clinops/*"
                  element={
                    <TabGuard tabId="clinops">
                      <ClinOpsRoutes />
                    </TabGuard>
                  }
                />
                <Route
                  path="dashboard/*"
                  element={
                    <TabGuard tabId="dashboard">
                      <DashboardRoutes />
                    </TabGuard>
                  }
                />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </MuiThemeProvider>
  );
}
